import { Checkbox, Flex, Select, Stack, Text, NumberInput } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { SyncRuleFormValues } from "./interface"
import { UseFormReturnType } from "@mantine/form"
import { useEffect } from "react"

export const RemindersInput = ({ form }: { form: UseFormReturnType<SyncRuleFormValues> }) => {
    const { t } = useTranslation(['app']);

    // By default, use default reminders
    useEffect(() => {
        if (!form.values.useReminders) {
            form.setFieldValue('reminders.useDefault', true)
        }
    }, [form.values.useReminders])

    // Clear overrides when useDefault is set to true
    useEffect(() => {
        if (form.values.reminders.useDefault) {
            form.setFieldValue('reminders.overrides', [])
        }
    }, [form.values.reminders.useDefault])

    // Ensure there's at least one override when not using default
    useEffect(() => {
        if (form.values.useReminders && !form.values.reminders.useDefault) {
            if (!form.values.reminders.overrides || form.values.reminders.overrides.length === 0) {
                form.setFieldValue('reminders.overrides', [{ method: 'email', minutes: 15 }])
            }
        }
    }, [form.values.useReminders, form.values.reminders.useDefault])

    return (
        <Stack gap="sm">
            <Text c='dimmed' size='sm'>{t('dashboard.sync.reminders.description')}</Text>
            <Checkbox
                label={t('dashboard.sync.reminders.add-reminders')}
                {...form.getInputProps('useReminders', { type: 'checkbox' })}
            />
            {form.values.useReminders && (
                <>
                    <Checkbox
                        label={t('dashboard.sync.reminders.use-default')}
                        {...form.getInputProps('reminders.useDefault', { type: 'checkbox' })}
                    />
                    {!form.values.reminders.useDefault && (
                        <>
                            <Text c='dimmed' size='sm'>{t('dashboard.sync.reminders.overrides')}</Text>
                            <Flex gap="md" align="flex-start">
                                <Select
                                    label={t('dashboard.sync.reminders.method')}
                                    data={[{ value: 'email', label: 'Email' }, { value: 'popup', label: 'Popup' }]}
                                    {...form.getInputProps('reminders.overrides.0.method')}
                                />
                                <NumberInput
                                    label={t('dashboard.sync.reminders.minutes')}
                                    placeholder="15"
                                    min={0}
                                    max={40320} // 4 weeks in minutes
                                    {...form.getInputProps('reminders.overrides.0.minutes')}
                                />
                            </Flex>
                        </>
                    )}
                </>
            )}
        </Stack>
    )
}